import { render, staticRenderFns } from "./HTMLContent.vue?vue&type=template&id=5a2624e3&scoped=true&"
import script from "./HTMLContent.vue?vue&type=script&lang=js&"
export * from "./HTMLContent.vue?vue&type=script&lang=js&"
import style0 from "./HTMLContent.vue?vue&type=style&index=0&id=5a2624e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2624e3",
  null
  
)

export default component.exports